<template>
    <div class="w-full">
        <div class="px-6 pt-6">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <Card
                    class="rounded-xl p-5 border border-gray-100 flex flex-col justify-center items-start"
                    style="
                        box-shadow: -6px 9px 24px 0px #0000000f;
                        background-color: #fcf4ff;
                    "
                >
                    <div class="flex items-start justify-between mb-3">
                        <div>
                            <Icon
                                icon-name="money_bag"
                                class-name="text-purple-600"
                                size="xs"
                            />
                        </div>
                    </div>
                    <div
                        class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                    >
                        Total {{ type }} Disbursed (YTD)
                    </div>
                    <div class="text-2xl font-bold text-jet">
                        {{ 0 }}
                    </div>
                </Card>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:col-span-3">
                    <div class="flex flex-col gap-2">
                        <Card
                            class="bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
                            style="box-shadow: -6px 9px 24px 0px #0000000f"
                        >
                            <div class="flex gap-1">
                                <div class="w-6 h-6">
                                <Icon class="icon-stat"
                                    icon-name="wallet-money"
                                    class-name="text-orange-600"
                                    size="xs"
                                />
                                </div>
                                <div
                                    class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                                >
                                    Outstanding Repayment (YTD)
                                </div>
                            </div>
                            <div class="text-base font-bold text-jet pl-7 m-top">
                                {{0}}
                            </div>
                        </Card>

                        <Card
                            class="bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
                            style="box-shadow: -6px 9px 24px 0px #0000000f"
                        >
                            <div class="flex gap-1">
                                <div class="w-6 h-6">
                                    <Icon class="icon-stat"
                                        icon-name="status-cancelled"
                                        class-name="text-orange-600"
                                        size="xs"
                                    />
                                </div>
                                <div
                                    class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                                >
                                    Pending Requests
                                </div>
                            </div>
                            <div class="text-base font-bold text-jet pl-7 m-top">
                                {{ 0 }}
                            </div>
                        </Card>
                    </div>
                    <div class="flex flex-col gap-2">
                        <Card
                            class="bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
                            style="box-shadow: -6px 9px 24px 0px #0000000f"
                        >
                            <div class="flex gap-1">
                                <div class="w-6 h-6">
                                    <Icon class="icon-stat"
                                        icon-name="success-filled"
                                        class-name="text-orange-600"
                                        size="xs"
                                    />
                                </div>
                                <div
                                    class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                                >
                                    Approved
                                </div>
                            </div>
                            <div class="text-base font-bold text-jet pl-7 m-top">
                                {{ 0 }}
                            </div>
                        </Card>
                        <Card
                            class="bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
                            style="box-shadow: -6px 9px 24px 0px #0000000f"
                        >
                            <div class="flex gap-1">
                                <div class="w-6 h-6">
                                    <Icon class="icon-stat"
                                        icon-name="cancel"
                                        class-name="text-orange-600"
                                        size="xs"
                                    />
                                </div>
                                <div
                                    class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                                >
                                    Disapproved
                                </div>
                            </div>
                            <div class="text-base font-bold text-jet pl-7 m-top">
                                {{0}}
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-2/4 flex text-jet text-sm flex-col justify-center items-center p-8 mx-auto mt-10 gap-2">
          <img :src="require('@/assets/images/Savings.png')" alt="not_found">
          <p class="font-norman text-base">
            {{ type }} request to be visible here
          </p>
        </div>
    </div>
</template>

<script>
import Card from "@/components/Card";
export default {
  name: "AdvanceLoanEmptyState",
   props: {
    type: {
      type: String,
      default: "",
    },
  },
  components: { Card },
  data() {
    return {
    };
  },
};
</script>